import { render, staticRenderFns } from "./TheCalculation.vue?vue&type=template&id=19219ea5&"
import script from "./TheCalculation.vue?vue&type=script&lang=js&"
export * from "./TheCalculation.vue?vue&type=script&lang=js&"
import style0 from "./TheCalculation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports